import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black bg-gold-gradient rounded-full shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(245,208,97,0.5)] transition-all duration-300 transform hover:scale-105';
  if (href) {
    return <motion.a href={href} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-39">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} {...props} data-id="element-40">
      {children}
    </motion.button>;
}